var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-panel"
  }, [_vm.loading ? _c('div', {
    staticClass: "bcg-loading"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "statistics"
  }, [_c('div', {
    staticClass: "stat-bar-filter"
  }, [_c('div', {
    staticClass: "filter-flex-custom"
  }, [_c('servis-filter-bar', {
    attrs: {
      "opportunities-only": _vm.opportunitiesOnly
    },
    on: {
      "opportunity-filter-change": _vm.setOpportunityFilter,
      "broker-filter-change": function brokerFilterChange($event) {
        return _vm.filterMortgages('financnik', $event);
      },
      "filter-client": function filterClient($event) {
        return _vm.filterMortgages('search', $event);
      }
    }
  })], 1)])]), _vm.opportunitiesOnly && !_vm.servisMortgages.length ? _c('p', {
    staticClass: "service-empty"
  }, [_vm._v("Zatiaľ tu nie sú klienti s aktuálnym upozornením. Všetky výsledky a chýbajúce údaje zobrazíte vypnutím filtra.")]) : _vm._e(), _c('div', {
    staticClass: "klienti-tabs w-tabs",
    attrs: {
      "data-current": "Tab 1",
      "data-easing": "ease",
      "data-duration-in": "300",
      "data-duration-out": "100"
    }
  }, [_c('div', {
    staticClass: "tabs-content-3 w-tab-content pb-5"
  }, [_c('div', {
    staticClass: "tab-pane-klienti w-tab-pane w--tab-active",
    attrs: {
      "data-w-tab": "Tab 1",
      "data-w-id": "155033eb-2d0e-aa7b-9a05-cefed74ed377"
    }
  }, [_c('div', {
    staticClass: "klienti-list"
  }, _vm._l(_vm.servisMortgages, function (mortgage) {
    return _c('div', {
      key: mortgage.id
    }, [_c('serviced-mortgage', {
      attrs: {
        "mortgage": mortgage
      }
    })], 1);
  }), 0)]), _vm.shouldDisplayNextPageButton() ? _c('div', {
    staticClass: "m-3 d-flex justify-content-center align-items-center"
  }, [_vm.loadingNextPage ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e(), _c('span', {
    staticClass: "text-small bl-color pointer",
    on: {
      "click": function click($event) {
        return _vm.nextPage();
      }
    }
  }, [_vm._v(" + načítaj ďalšie ")])]) : _vm._e()])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }